import SjQuestionFileProgress from '../sj-question-file/src/SjQuestionFileProgress.vue'

export default SjQuestionFileProgress



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-file-progress/index.js